export const validEmailWithRegex = (email: string): boolean => {
  // eslint-disable-next-line no-useless-escape
  const validEmailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i

  return Boolean(email.match(validEmailRegex))
}
